// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".single-item[data-v-52a9bc05]{width:270px;max-width:270px}.single-item[data-v-52a9bc05]:hover{text-decoration:none;opacity:.8}.single-item:hover .q-title[data-v-52a9bc05]{color:#7dcfc4!important}.single-item.desktop[data-v-52a9bc05]{width:370px!important;max-width:unset}a[data-v-52a9bc05]:hover{text-decoration:none;color:#7dcfc4!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
